import App from "./App.svelte";
var Precision;
(function (Precision) {
    Precision[Precision["secs"] = 0] = "secs";
    Precision[Precision["millis"] = 1] = "millis";
    Precision[Precision["micros"] = 2] = "micros";
    Precision[Precision["nanos"] = 3] = "nanos";
})(Precision || (Precision = {}));
;
function getStrings(numbers, unit, precision, iso, local) {
    return numbers.map((number, index, arr) => {
        const dateTime = new Date(Number(number) * unit);
        let offset = dateTime.getTimezoneOffset();
        const signOffset = offset <= 0 ? '+' : '-';
        let hourOffset = offset <= 0 ? (-offset / 60) : (offset / 60);
        let minOffset = offset <= 0 ? (-offset % 60) : (offset & 60);
        if (hourOffset < 10) {
            hourOffset = '0' + hourOffset;
        }
        if (minOffset < 10) {
            minOffset = '0' + minOffset;
        }
        const year = local ? dateTime.getFullYear() : dateTime.getUTCFullYear();
        let month = 1 + (local ? dateTime.getMonth() : dateTime.getUTCMonth());
        if (month < 10) {
            month = '0' + month;
        }
        let day = local ? dateTime.getDate() : dateTime.getUTCDate();
        if (day < 10) {
            day = '0' + day;
        }
        let hour = local ? dateTime.getHours() : dateTime.getUTCHours();
        if (hour < 10) {
            hour = '0' + hour;
        }
        let min = local ? dateTime.getMinutes() : dateTime.getUTCMinutes();
        if (min < 10) {
            min = '0' + min;
        }
        let sec = local ? dateTime.getSeconds() : dateTime.getUTCSeconds();
        if (sec < 10) {
            sec = '0' + sec;
        }
        const pointNextPos = number.includes('.') ? 11 : 10;
        let afterSeconds;
        if (precision === Precision.secs) {
            afterSeconds = null;
        }
        else if (pointNextPos < number.length) {
            afterSeconds = number.substr(pointNextPos);
            switch (precision) {
                case Precision.millis:
                    if (afterSeconds.length < 3) {
                        const loop = 3 - afterSeconds.length;
                        for (let i = 0; i < loop; ++i) {
                            afterSeconds = afterSeconds + '0';
                        }
                    }
                    else if (afterSeconds.length > 3) {
                        afterSeconds = afterSeconds.substr(0, 3);
                    }
                    break;
                case Precision.micros:
                    if (afterSeconds.length < 6) {
                        const loop = 6 - afterSeconds.length;
                        for (let i = 0; i < loop; ++i) {
                            afterSeconds = afterSeconds + '0';
                        }
                    }
                    else if (afterSeconds.length > 6) {
                        afterSeconds = afterSeconds.substr(0, 6);
                    }
                    break;
                case Precision.nanos:
                    if (afterSeconds.length < 9) {
                        const loop = 9 - afterSeconds.length;
                        for (let i = 0; i < loop; ++i) {
                            afterSeconds = afterSeconds + '0';
                        }
                    }
                    else if (afterSeconds.length > 9) {
                        afterSeconds = afterSeconds.substr(0, 9);
                    }
                    break;
            }
        }
        else {
            switch (precision) {
                case Precision.millis:
                    afterSeconds = '000';
                    break;
                case Precision.micros:
                    afterSeconds = '000000';
                    break;
                case Precision.nanos:
                    afterSeconds = '000000000';
                    break;
            }
        }
        if (iso) {
            if (afterSeconds != null) {
                if (local) {
                    return year + '-' + month + '-' + day + 'T' + hour + ':' + min + ':' + sec + '.' + afterSeconds + signOffset + hourOffset + ':' + minOffset;
                }
                else {
                    return year + '-' + month + '-' + day + 'T' + hour + ':' + min + ':' + sec + '.' + afterSeconds + 'Z';
                }
            }
            else {
                if (local) {
                    return year + '-' + month + '-' + day + 'T' + hour + ':' + min + ':' + sec + signOffset + hourOffset + ':' + minOffset;
                }
                else {
                    return year + '-' + month + '-' + day + 'T' + hour + ':' + min + ':' + sec + 'Z';
                }
            }
        }
        else {
            if (afterSeconds != null) {
                return year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec + '.' + afterSeconds;
            }
            else {
                return year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec;
            }
        }
    });
}
function replaceText(text, prec, iso, local) {
    const precision = Precision[prec];
    // 小数点で秒単位？
    let numbers = text.match(/\b\d{10}\.\d+/g);
    let unit = 1000;
    if (numbers != null) {
        const strings = getStrings(numbers, unit, precision, iso, local);
        numbers.forEach((number, index, arr) => {
            text = text.replace(number, strings[index]);
        });
    }
    // ナノ秒単位？
    numbers = text.match(/\b\d{19}\b/g);
    unit = 0.000001;
    if (numbers != null) {
        const strings = getStrings(numbers, unit, precision, iso, local);
        numbers.forEach((number, index, arr) => {
            text = text.replace(number, strings[index]);
        });
    }
    // マイクロ秒単位？
    numbers = text.match(/\b\d{16}\b/g);
    unit = 0.001;
    if (numbers != null) {
        const strings = getStrings(numbers, unit, precision, iso, local);
        numbers.forEach((number, index, arr) => {
            text = text.replace(number, strings[index]);
        });
    }
    // ミリ秒単位？
    numbers = text.match(/\b\d{13}\b/g);
    unit = 1;
    if (numbers != null) {
        const strings = getStrings(numbers, unit, precision, iso, local);
        numbers.forEach((number, index, arr) => {
            text = text.replace(number, strings[index]);
        });
    }
    // 秒単位？
    numbers = text.match(/\b\d{10}\b/g);
    unit = 1000;
    if (numbers != null) {
        const strings = getStrings(numbers, unit, precision, iso, local);
        numbers.forEach((number, index, arr) => {
            text = text.replace(number, strings[index]);
        });
    }
    return text;
}
const app = new App({
    target: document.body,
    props: {
        replaceText: replaceText,
        Precision: Precision,
        handleClickCopy: () => {
            const out = document.getElementById("output-text");
            out.select();
            document.execCommand("copy");
            out.selectionStart = out.selectionEnd;
        }
    }
});
export default app;
